import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2InteriorConfiguratorImage from './X46MK2InteriorConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import MaterialSelector from '../MaterialSelector'
import { withTranslation, Trans } from 'react-i18next'
import { interiorView03ImageOptions } from './views/InteriorView03'

class X46MK2Fabric extends Component {
  constructor (props) {
    super(props)
    this.handleFabricChange = this.handleFabricChange.bind(this)
  }

  handleFabricChange (newValue) {
    const configuration = this.props.configuration
    configuration.FabricSaloon = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    const image = (
      <X46MK2InteriorConfiguratorImage
        boat='X46MK2'
        configuration={this.props.configuration}
        options={interiorView03ImageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='SALOON' />
          </h1>
          <h2>
            <Trans defaults='Fabric saloon' />
          </h2>
          <MaterialSelector
            options={this.props.fabricSaloonOptions || this.props.fabricOptions}
            label={this.props.configuration.FabricSaloon.label}
            value={this.props.configuration.FabricSaloon}
            onChange={this.handleFabricChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2Fabric)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2Fabric.js